import { api } from '@/api'
import type { ApiResponse } from '@/api/typings/response.typing'

export interface RejectSelfieUserResponse {
  data: null
  meta: {
    message: string
    errors: string[]
  }
}

export function rejectSelfieUserAction(userId: string): Promise<ApiResponse<RejectSelfieUserResponse>> {
  return api.put<ApiResponse<RejectSelfieUserResponse>>(`/users/${userId}/reject-identification-selfie`)
}
